import { render, staticRenderFns } from "./ImportAddressRegisterDlg.vue?vue&type=template&id=7dded272"
import script from "./ImportAddressRegisterDlg.vue?vue&type=script&lang=js"
export * from "./ImportAddressRegisterDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports